import React, {useState} from 'react';
import './App.scss';
import HorizontalDivider from "./ui/horizontaldivider/horizontaldivider";
import Dropdown from "./ui/dropdown/dropdown";
import {DropDownItem} from "./modals/types/dropdown";
import Button from "./core/button/button";
import ServiceCard, {IServiceCard} from "./ui/servicecard/servicecard";
import SelectableSlider from "./ui/slider/selectableslider/selectableslider";
import SelectableSliderItem, {ISelectableSliderItem} from "./ui/selectableslideritem/selectableslideritem";
import ContentSlider from "./ui/slider/contentslider/contentslider";
import {ContentsSlide} from "./modals/types/content";

function App() {
    const [activate, setActivate] = useState("item0");
    const adGoalDropDownItems: DropDownItem[] = [
        {label: "1"}, {label: "2"}, {label: "3"}, {label: "4"}
    ];
    const sliderItems: ISelectableSliderItem[] = [
        {
            image: require("./assets/images/icons/GoalSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/SpeakerSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/LightBulbSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/BrowserSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/BrowserSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/LightBulbSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/GoalSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/SpeakerSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        }, {
            image: require("./assets/images/icons/BrowserSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/LightBulbSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/GoalSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/SpeakerSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        }, {
            image: require("./assets/images/icons/GoalSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/SpeakerSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/LightBulbSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/BrowserSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/BrowserSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/LightBulbSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/GoalSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/SpeakerSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        }, {
            image: require("./assets/images/icons/BrowserSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/LightBulbSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/GoalSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
        {
            image: require("./assets/images/icons/SpeakerSSlider.svg").default,
            title: "تبلیغات در تی وی",
            activate: activate,
            setActivate: setActivate,
            id: 0
        },
    ]

    let allSliderItems: JSX.Element[] = [];
    const renderSliderItems = (items: ISelectableSliderItem[]): JSX.Element[] => {
        items.map((item, index) => {
            allSliderItems.push(
                <SelectableSliderItem activate={activate} setActivate={setActivate} id={index} key={index}
                                      image={item.image} title={item.title}/>
            )
            return <></>;
        })
        return allSliderItems;
    }
    const serviceCardItem: IServiceCard[] = [
        {
            image: require("./assets/images/icons/Trumpet.png"),
            title: 'تبلیغ دهنده',
            body: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها' +
                'و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است لورم ایپسوم متن ساختگی با تولید سادگی' +
                ' نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و' +
                '                    سطرآنچنان که لازم است'
        }, {
            image: require("./assets/images/icons/Rocket.png"),
            title: 'تبلیغ شونده',
            body: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها' +
                'و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است لورم ایپسوم متن ساختگی با تولید سادگی' +
                ' نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و' +
                '                    سطرآنچنان که لازم است'
        },
    ]

    const sliderContents: ContentsSlide[] = [
        {
            image: require("./assets/images/photos/ArticleImage1.png"),
            title: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید",
            author: "نویسنده: مدیر وبسایت",
            date: "انتشار: 1401/07/25 ",
            desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در  کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد"
        }, {
            image: require("./assets/images/photos/ArticleImage2.png"),
            title: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید",
            author: "نویسنده: مدیر وبسایت",
            date: "انتشار: 1401/07/25 ",
            desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در  کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد"
        }, {
            image: require("./assets/images/photos/ArticleImage3.png"),
            title: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید",
            author: "نویسنده: مدیر وبسایت",
            date: "انتشار: 1401/07/25 ",
            desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در  کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد"
        }, {
            image: require("./assets/images/photos/ArticleImage4.png"),
            title: "با شناخت تبلیغات و روش‌های آن، تبلیغات خود را هدفمند کنید",
            author: "نویسنده: مدیر وبسایت",
            date: "انتشار: 1401/07/25 ",
            desc: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در  کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد"
        },
    ]
    return (
        <div className="Home-Page">
            <div className="container" style={{clear: 'both'}}>
                <div className="Recommend-Box">
                    <h6>پیشنهاد تیجار با انتخاب هدف</h6>
                    <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است
                        چاپگرها و
                        متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است</p>
                    <HorizontalDivider/>
                    <div className="row">
                        <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 mt-2">
                            <div className="Drop-Down-Icon-Group speaker">
                                <Dropdown items={adGoalDropDownItems} placeHolder="هدف تبلیفات"/>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 mt-2">
                            <div className="Drop-Down-Icon-Group briefcase">
                                <Dropdown items={adGoalDropDownItems} placeHolder="حوزه کاری شما"/>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 mt-2">
                            <div className="Drop-Down-Icon-Group user">
                                <Dropdown items={adGoalDropDownItems} placeHolder="مخاطب هدف شما"/>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 mt-2">
                            <div className="Drop-Down-Icon-Group global">
                                <Dropdown items={adGoalDropDownItems} placeHolder="بستر تبلیغات"/>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 mt-2">
                            <div className="Drop-Down-Icon-Group vuesax">
                                <Dropdown items={adGoalDropDownItems} placeHolder="بودجه"/>
                            </div>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 mt-2">
                            <Button type={"secondary"} action={() => {
                            }} responsive={true}>شروع تبلیغات</Button>
                        </div>
                    </div>
                </div>
                <div className="Services-Box">
                    <h6>خدمات تیجار</h6>
                    <h3>ما در تیجار چه کاری انجام می دهیم؟</h3>
                    <p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است
                        چاپگرها و
                        متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است لورم ایپسوم متن ساختگی با تولید سادگی
                        نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون
                        و
                        سطرآنچنان که لازم است</p>
                </div>
                <div className="Slider-Box">
                    <SelectableSlider sliderItems={renderSliderItems(sliderItems)}/>
                </div>
            </div>
            <div className="bg-white">
                <div className="container">
                    <div className="row Service-Card-Container">
                        {
                            serviceCardItem.map((serviceCardItem, index) => {
                                return (
                                    <div key={index} className="col-lg-6 col-12 mb-3">
                                        <ServiceCard body={serviceCardItem.body} image={serviceCardItem.image}
                                                     title={serviceCardItem.title}/>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
            <div className="container">
                <ContentSlider data={sliderContents}/>
            </div>
        </div>
    );
}

export default App;
